import {getExtensionFromMimeType} from "./getExtensionFromMimeType";

export const urlToFile = async (url: string, filename?: string): Promise<File | null> => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();

        let contentType = response.headers.get('content-type') || 'application/octet-stream';

        // Fallback filename if not provided
        let baseName = filename || url.split('/').pop() || `file-${Date.now()}`;

        // Add extension if not present
        if (!baseName.includes('.')) {
            const extension = getExtensionFromMimeType(contentType);
            baseName += `.${extension}`;
        }

        return new File([blob], baseName, {type: contentType});
    } catch (error) {
        console.error('[urlToFile] Failed to convert URL to file:', error);
        return null;
    }
};

export const dataUrlToFile = (dataUrl: string, filename?: string): File | null => {
    try {
        const arr = dataUrl.split(',');
        if (arr.length < 2) {
            return null;
        }
        const mimeMatch = arr[0].match(/:(.*?);/);
        const mime = mimeMatch?.[1] || 'image/jpeg';
        let baseName = filename || `file-${Date.now()}`;
        if (!baseName.includes('.')) {
            const extension = getExtensionFromMimeType(mime);
            baseName += `.${extension}`;
        }

        const bstr = atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);
        for (let i = 0; i < n; i++) {
            u8arr[i] = bstr.charCodeAt(i);
        }
        return new File([u8arr], baseName, {type: mime});
    } catch (e) {
        console.error('[dataUrlToFile] Failed to convert data URI to file:', e);
        return null;
    }
}
